import { Box } from "@material-ui/core";
import React, { useEffect } from "react";
import CircularStatic from "../../../../../components/CircularTimeOut/CircularStatic";
import { navigateUrl } from "../../../../../utils";

const ImgModal = ({ close, media, adTimer, showCloseIcon }) => {
  useEffect(() => {
    const timeoutId = setTimeout(function () {
      close();
    }, 10000 * adTimer.ad_time);

    return () => clearTimeout(timeoutId); 
  }, [adTimer.ad_time, close]);

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
      {!showCloseIcon && (
          <div style={{ position: "fixed", left: "92%", top: "2%" }}>
            <CircularStatic ad_time={adTimer.ad_time} />
          </div>
        )}
        <img
          style={{ width: "100%", height: 500, objectFit: "contain" }}
          src={media?.ad_file}
          onClick={() => navigateUrl(media.redirect_url)}
          alt="Ad Image"
        />
      </form>
    </Box>
  );
};

export default ImgModal;
